import PropTypes from 'prop-types'

/**
 * @typedef {Object} GrantedRightLevel
 * @property {string} [rightLevelId] - The ID of the right level.
 * @property {string} [name] - The internal name of the right level. Use 'stringCode' incl. proper translation to get
 *   the display name. Unique within WEBFLEET.
 * @property {boolean} [entityAllowed=true] - TRUE if this right level can be granted to a specific entity.
 * @property {boolean} [entityGroupAllowed=true] - TRUE if this right level can be granted to a specific entity group.
 * @property {string} [stringCode] - String code corresponding to a human readable translation.
 * @property {string} [entityId] - The entity ID this right level is about. entityId and entityGroupId are mutually
 *   exclusive: If entityId is given, entityGroupId must not be set and vice versa. Additionally, both can be NULL.
 * @property {string} [entityGroupId] - Entity group ID this right level is about entityId and entityGroupId are
 *   mutually exclusive: If entityId is given, entityGroupId must not be set and vice versa. Additionally, both can be
 *   NULL.
 * @property {string} [entityType] - The type of the entity that entityId or entityGroupId refer to (when given).
 */
export const grantedRightLevelPropType = PropTypes.shape({
    entityAllowed: PropTypes.bool,
    entityGroupAllowed: PropTypes.bool,
    entityGroupId: PropTypes.string,
    entityId: PropTypes.string,
    entityType: PropTypes.string,
    name: PropTypes.string,
    rightLevelId: PropTypes.string,
    stringCode: PropTypes.string
})
